import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { useEthers } from './useEthers';
/**
 * `useResolveName` is a hook that is used to resolve an ENS name (e.g. `name.eth`) to a specific address.
 * @param name ENS name to be resolved
 * @returns {} Object with the following:
  - `address: string | null | undefined` - resolved address for the given ENS name or null if not found.
  - `isLoading: boolean` - indicates whether the lookup is in progress.
  - `error: Error | null` - error that occurred during the lookup or null if no error occurred.
 * @public
 */
export var useResolveName = function useResolveName(name) {
  var _useEthers = useEthers(),
    library = _useEthers.library;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    address = _useState6[0],
    setAddress = _useState6[1];
  useEffect(function () {
    var mounted = true;
    void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var resolved;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!library || !name)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            setIsLoading(true);
            _context.next = 6;
            return library.resolveName(name);
          case 6:
            resolved = _context.sent;
            if (mounted) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return");
          case 9:
            setAddress(resolved);
            _context.next = 17;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            if (mounted) {
              _context.next = 16;
              break;
            }
            return _context.abrupt("return");
          case 16:
            setError(_context.t0);
          case 17:
            _context.prev = 17;
            setIsLoading(false);
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12, 17, 20]]);
    }))();
    return function () {
      mounted = false;
    };
  }, [library, name]);
  return {
    address: address,
    isLoading: isLoading,
    error: error
  };
};